<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-16 08:53:39
 * @LastEditTime: 2021-09-08 17:00:09
 * @LastEditors: qiye
 -->
<template>
  <div class="header-wrap">
    <div class="navigation-inner">

      <ul id="borderBottom">
        <!-- 默认被选中项 -->
        <li class="logo">
          <img src="@/assets/img/logo.png" alt />
        </li>
        <li
          ref="nav"
          v-for="i in nevigatelist"
          :key="i.id"
          @click="onclick(i.id)"
          @mouseover="onDplOver($event, i.nav)"
          @mouseleave="onDplOver2()"
        >
          <h2>
            <a :href="i.href" :target="i.target ? i.target:'_self'" >{{ i.label }}</a>
          </h2>
        </li>

      </ul>
    </div>
    <!---->
    <div class="navigation-down navigation-down-inner"  ref="inner" >
      <div class=""  @mouseleave="onDpOut()">
        <ul v-for="(itpx,index) in listMe(navdetails, nav)" :key="index" :class="itpx.id == 'login' ? 'navLogin' : itpx.id == 'solution' || 'hardware' ? 'navSolution' :'navSolution'"  >
          <li v-for="(itpx2,index) in itpx.childrenlist" :key="index" @click="onclick(itpx.nevigatelistId)">
            <!--  v-show="itpx2.href != '#'" -->
            <div class="headertopimg">
              <a :href="itpx2.href" target="_blank">
                <img :src="itpx2.img" alt/>
              </a>
            </div>
            <div class="text-center">
              <!--   <span class="tf"></span> -->
              <a :href="itpx2.href" target="_blank">{{ itpx2.label }}</a>
            </div>
          </li>
          <div style="clear:both"></div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import footer from "./footer";
export default {
  data() {
    return {
      active: true,
      nav: "",
      id: "0",
      navId: "",
      nevigatelist: [
        {
          id: "1",
          nav: "home",
          href: "/cn/",
          label: "首页"
        },
        {
          id: "2",
          nav: "product",
          href: "/cn/product",
          label: "软件系统"
        },
        {
          id: "3",
          nav: "hardware",
          href: "/cn/hardware/all.html",
          label: "智能硬件"
        },
        {
          id: "4",
          nav: "solution",
          href: "/cn/program",
          label: "解决方案"
        },
        {
          id: "5",
          nav: "applications",
          href: "/cn/caseshow",
          label: "应用案例"
        },
        {
          id: "6",
          nav: "news",
          href: "/cn/news",
          label: "新闻资讯"
        },
        {
          id: "7",
          nav: "service",
          href: "/cn/service",
          label: "应用中心"
        },
        {
          id: "8",
          nav: "aboutus",
          href: "/cn/about",
          label: "关于我们"
        },
        {
          id: "9",
          nav: "login",
          href: "https://www.yunbiao.tv/background/login.html",/* https://www.yunbiao.tv/background/login.html */
          target:"_blank",
          label: "云平台登录"
        },
        // {
        //   id: "10",
        //   nav: "shop",
        //   href: "https://shop156993419.taobao.com/",/* https://www.yunbiao.tv/background/login.html */
        //   target:"_blank",
        //   label: "淘宝企业店"
        // },

      ],
      /* 导航内明细列表 */
      navdetails: [
        {
          id: "product",
          /* 明细列表标题下内容 */
          nevigatelistId:'2',
          childrenlist: [
            {
              id: "1",
              href: "/cn/information",
              img: require('./images/信息发布系统.png'),
              label: ""
            },
            {
              id: "2",
              href: "/cn/touchquery",
              img: require('./images/触摸查询系统.png'),
              label: ""
            },
            {
              id: "3",
              href: "/cn/office",
              img: require('./images/AI人脸识别系统.png'),
              label: ""
            },
            {
              id: "4",
              href: "/cn/CloudShelf",
              img: require('./images/新零售云货架系统.png'),
              label: ""
            }
          ]
        },
        {
          id: "hardware",
          nevigatelistId:'3',
          childrenlist: [
            {
              id: "1",
              href: "/cn/hardware/223",
              img: require("./images/信息发布系列.jpg"),
              label: "信息发布系列"
            },
            {
              id: "2",
              href: "/cn/hardware/262",
              img: require("./images/触摸查询系列.jpg"),
              label: "触摸查询系列"
            },
            {
              id: "3",
              href: "/cn/hardware/263",
              img: require("./images/AI人脸识别系列.jpg"),
              label: "AI人脸识别系列"
            },
            {
              id: "4",
              href: "/cn/hardware/201",
              img: require("./images/自助新零售导航.png"),
              label: "自助新零售系列"
            },
            {
              id: "5",
              href: "/cn/XFBox",
              img: require("./images/d28f3897d27d8974ac39b62d792988b.png"),
              label: "多媒体信息发布盒"
            }

          ]
        },
        {
          id: "solution",
          nevigatelistId:'4',
          childrenlist: [
            {
              id: "1",
              href: "/cn/solution",
              img: require('./images/20191008004.jpg'),
              label: ""
            },
            {
              id: "2",
              href: "/cn/shangxian",
              img: require('./images/20191008002.jpg'),
              label: ""
            },
            {
              id: "3",
              href: "/cn/SXTouch",
              img: require('./images/20191008005.jpg'),
              label: ""
            },
            {
              id: "4",
              href: "/cn/CloudShelf",
              img: require('./images/20191008003.jpg'),
              label: ""
            },
            {
              id: "4",
              href: "/cn/IntelligentMeeting",
              img: require('./images/20191008001.jpg'),
              label: ""
            },
          ]
        },
        /* {
          id: "service",
          nevigatelistId:'7',
          childrenlist: [
            {
              id: "1",
              href: "/cn/service",
              img: "",
              label: "软件下载"
            }
          ]
        }, */
        {
          id: "aboutus",
          nevigatelistId:'8',
          childrenlist: [
            {
              id: "1",
              href: "/cn/about#gsjs",
              img: require('./images/关于云标.png'),
              label: ""
            },
            {
              id: "2",
              href: "/cn/about#hzhb",
              img: require('./images/合作伙伴.png'),
              label: ""
            },
            {
              id: "3",
              href: "/cn/about#ryzz",
              img: require('./images/荣誉资质.png'),
              label: ""
            },
            {
              id: "4",
              href: "/cn/about#lxwm",
              img: require('./images/联系我们.png'),
              label: ""
            }
          ]
        },
        {
              id: "login",
              nevigatelistId:'9',
              childrenlist: [
                {
                  id: "1",
                  href: "http://ai.yunbiao.tv",
                  img: require('./images/c34d1d535b4329197eb386cb6af17e3.jpg'),
                  label: ""
                },
                {
                  id: "2",
                  href: "http://buy.yunbiao.tv",
                  img: require('./images/2796d57bd27c219506ebafa0bee7503.jpg'),
                  label: ""
                },
                {
                  id: "3",
                  href: "http://www.yunbiao.tv/background/login.html",
                  img: require('./images/6d1e4b7e57e16d33500afd5ce19d15f.jpg'),
                  label: ""
                },
              ]
            },
      ]
    };
  },
  methods: {
    /* 点击触发 */
    onclick(id) {
      this.id = id - 1;
    },
    onDplOver(e, i) {
      this.nav = i;
      this.$refs.inner.className = "navigation-down navigation-down-inner";
      if(this.nav != 'hardware'){
        this.$refs.inner.className = "navigation-down navigation-down-inner imgMargin";
      }
       if(this.nav == 'login'){
        this.$refs.inner.className = "navigation-down navigation-down-inner imgMargin ";
      }
    },
    onDplOver2() {
      this.$refs.inner.className = "navigation-down ";
      if(this.nav != 'hardware'){
        this.$refs.inner.className = "navigation-down imgMargin";

      }
    },
    onDpOut() {
      this.nav = "";
      this.$refs.inner.className = "navigation-down";
      if(this.nav != 'hardware'){
        this.$refs.inner.className = "navigation-down imgMargin";

      }
    },
    listMe: function(list, nav) {
      return list.filter(function(itpx) {
        // console.log(itpx.id +'------' + nav)
        return itpx.id == nav;
      });
    }
  },
  mounted() {
    var newid = sessionStorage.newid;
    // if (newid == undefined &&  this.$refs.nav[this.id].className){
    //   this.$refs.nav[this.id].className = "lifocus";
    // }
    if(newid){

      this.$refs.nav[newid].className = "lifocus";
    }else{

      this.$refs.nav[0].className = "lifocus";
    }
  },
  watch: {

    id: function(newid) {

      sessionStorage.setItem("newid", newid);

      for (let i = 0; i < this.$refs.nav.length; i++) {
        this.$refs.nav[i].className = "";
      }
      this.$refs.nav[newid].className = "lifocus";
    }
  },
  destroyed() {
    sessionStorage.clear();
  },
  components: {
    "v-footer": footer
  }
};
</script>


<style lang="stylus" rel="stylesheet/stylus" scoped>
.navLogin{
   display:flex;
   justify-content center
}
.logo {
  /* width: 0.75rem;
  height: 0.2rem; */

  img {
    width: 100%;
    height: 100%;
  }
}

.headertopimg {
  text-align: center;
  margin-bottom: 3%;
  /* width 50% */
  margin: 0 auto;

  img {
    margin-bottom: 6px;
  }
}

.lifocus {
  a {
    border-bottom: 2px solid #1dadce;
  }
}

/* span {
  background: url('~@/assets/img/false.png') center center no-repeat;
  background-size: cover;
  display: inline-block;
  margin-right: 2px;
  width: 15px;
  height: 15px;
  padding-top: 2px;
} */
.header-wrap {
  position: absolute;
  min-width: 100%;
  height: 113px;
  white-space: nowrap;
}

.navigation-inner {
  height: 65px;
  background: #363636;
  position: fixed;
  width: 100%;
  z-index: 999;

  ul {
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;

    li {
      h2 {
        a {
          color: #fff;
          padding-bottom: 2px;

          &:hover {
            border-bottom: 2px solid #1dadce;
          }
        }
      }

      margin-right: 2%;
      font-size: 16px;

      .btn {
        padding: 2px 6px;
        border: 1px solid #1AA3C4;
        border-radius: 10px;
        color: #1AA3C4;
        font-weight: 500;
        font-size: 16px;
        background: #363636;

        &:hover {
          background: #1AA3C4;
          color: #fff;
        }
      }

      &:nth-child(2) {
        padding-left: 2%;
      }

      &:nth-child(11) {
        margin-right: 0%;
      }
    }
  }
}
.navigation-down-inner {
    /* padding-left: 8%; */
    animation-fill-mode: none;
    animation: fade-in; /* 动画名称 */
    animation-duration: 1.5s; /* 动画持续时间 */
    -webkit-animation: fade-in 1.5s; /* 针对webkit内核 */
    -o-animation fade-in 1.5s
    -moz-animation fade-in 1.5s
    -ms-zoom-animation fade-in 1.5s

   @keyframes fade-in {
      from {
        opacity: 0;
        transform translate(0, -80px)
        -webkit-transform: translate(0, -80px); /* Safari, 谷歌浏览器等使用Webkit引擎的浏览器  */
        -o-transform translate(0, -80px) /* Opera浏览器(早期) */
        -moz-transform translate(0, -80px) /* 火狐等使用Mozilla浏览器引擎的浏览器 */
        -ms-zoom-animation translate(0, -80px)  /* Internet Explorer (不一定) */
        transform: stranslate(0, -80px); /* 标准语法 */
      }

      to {
        opacity: 1;
        transform: translate(0, 0px)
        -webkit-transform: translate(0, 0px);
        -o-transform: translate(0, 0px);
        -moz-transform: translate(0, 0px);
        -ms-zoom-transform: translate(0, 0px);
        transform: stranslate(0, 0px); /* 标准语法 */
      }
    }
  }
.navigation-down {
  position: absolute;
  top: 65px;
  width: 100%;
  background: #EBEBEB;
  white-space: nowrap;
  position: fixed;
  z-index: 20;
  padding-left: 10%;
  padding-right: 10%;
  img{
    border-radius 5%
  }


  ul {
    padding-bottom: 2%;

    li {
      float: left;
      width: 25%;
      padding-top: 1%;


      a {
        color: #000;
        font-size: 0.083rem;
      }

      /* &:hover {
        span {
          background: url('~@/assets/img/true.png') center center no-repeat;
          background-size: cover;
        }
      } */
    }
  }
}
.imgMargin{
  padding-left: 15%;
  padding-right: 15%;
  img{
    width:90%;
    height:90%;
  }
}
.navSolution{
  display:flex;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue